import PropTypes from 'prop-types';
import { clsx } from 'clsx';
import ChevronDownIcon from './icons/chevrondown.svg?react';

export function NavButton({
  icon,
  menuIsOpen,
  label,
  onClick,
  active = false,
  showChevron = false,
  className = '',
  disabled = false,
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        'flex items-center justify-between w-full',
        'h-7 px-spacing-2 rounded',
        'text-sm text-primary',
        'transition-colors duration-200',
        'focus:outline-none focus:bg-bg-hover',
        active
          ? 'bg-bg-hover'
          : 'hover:bg-bg-hover hover:text-primary',
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
    >
      {!menuIsOpen && icon ? (
        <span className="size-4 flex-shrink-0">{icon}</span>
      ) : menuIsOpen ? (
        <>
          <div className="flex items-center gap-spacing-2 min-w-0">
            {icon ? (
              <span className="size-4 flex-shrink-0">{icon}</span>
            ) : (
              <span className="size-4 flex-shrink-0" aria-hidden="true" />
            )}
            <span className="truncate">{label}</span>
          </div>
          {(showChevron) && (
            <div className="flex items-center gap-spacing-2 ml-auto pl-spacing-2 flex-shrink-0">
              {showChevron && (
                <ChevronDownIcon
                  className={clsx(
                    'size-4 transition-transform duration-300',
                    active && 'rotate-180'
                  )}
                  aria-hidden="true"
                />
              )}
            </div>
          )}
        </>
      ) : null}
    </button>
  );
}

NavButton.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  showChevron: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  menuIsOpen: PropTypes.bool,
};
